import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'

const Annoucements = () => {
  return (
    <>
      <Row className='bg-7 px-2 py-4'>
        <Col md={8}>

          <img src={require('../../Assets/explore/Imagen4.png')} alt="" className='img-fluid w-100' />

          <Row>
            <Col>
              <Card className='border-0 p-2 gradient-div-green '>
                <div className='d-flex'>
                  <div>
                    <img src={require('../../Assets/explore/rect1.png')} alt="" className='img-fluid ' />
                  </div>
                  <h2 className='text-bold ms-2'>Udemy Enrollment got updated!</h2>
                </div>
                <div className='pt-3 ' >
                  <p>We got new features and improvements to bring you more accurate and interesting analysis!</p>
                </div>
              </Card>
            </Col>
            <Col>
              <Card className='border-0 p-2 gradient-div-blue ' >
                <div className='d-flex'>
                  <div>
                    <img src={require('../../Assets/explore/rect2.png')} alt="" className='img-fluid ' />
                  </div>
                  <h2 className='text-bold ms-2'>Udemy Enrollment got updated!</h2>
                </div>
                <div className='pt-3' >
                  <p>We got new features and improvements to bring you more accurate and interesting analysis!</p>
                </div>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <div className='w-100 min-h-150'>
            <h3>Remember we have demos!</h3>
            <p className='fs-24'>If an app interests you, tray the demo version to know a <br /> lot more about it and discover its great potential.</p>
          </div>
          <div>
            <img src={require('../../Assets/explore/Imagen5.png')} alt="" className='img-fluid' />
          </div>
        </Col>
      </Row>

    </>
  )
}

export default Annoucements